import { render, staticRenderFns } from "./BackofficeDadosAnestesia.vue?vue&type=template&id=32c6574e&scoped=true"
import script from "./BackofficeDadosAnestesia.vue?vue&type=script&lang=ts"
export * from "./BackofficeDadosAnestesia.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeDadosAnestesia.vue?vue&type=style&index=0&id=32c6574e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6574e",
  null
  
)

export default component.exports